<script>
import vBase from './vBase'
import {vRecordMixin} from 'crud-vue-core'


export default {
  name: 'v-record',
  extends: vBase,
  mixins: [vRecordMixin]
}
</script>

<style scoped>

</style>
